import { render, staticRenderFns } from "./GroupApplicant.vue?vue&type=template&id=c4a08666"
import script from "./GroupApplicant.vue?vue&type=script&lang=js"
export * from "./GroupApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports